export enum DeviceStatus {
    FREE = '1001',
    OCCUPIED = '1002',
    REPAIR = '1003',
    DAMAGED = '1004',
}